(function () {
  function createQuickdrawerElement(element) {
    const item = element;

    // Agar already button add ho chuka hai to dobara skip karein
    if (item.querySelector("quick-buy-button")) return;

    const productTitle =
      item.querySelector('.card__heading, [class*="title"]')?.textContent?.trim() ||
      "Product";

    // --- Quick Buy Button banayein ---
    const quickBuyButton = document.createElement("quick-buy-button");
    quickBuyButton.className = "card__quick-add-btn";
    quickBuyButton.setAttribute("aria-label", `Quick add: ${productTitle}`);
    quickBuyButton.innerHTML = `
      <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.4962 4.005C16.3824 3.87727 16.2428 3.77513 16.0866 3.70532C15.9304 3.63551 15.7612 3.59961 15.5902 3.6H11.9962C11.9962 2.64522 11.6169 1.72955 10.9418 1.05442C10.2666 0.379285 9.35095 0 8.39617 0C7.44139 0 6.52572 0.379285 5.85059 1.05442C5.17546 1.72955 4.79617 2.64522 4.79617 3.6H1.20217C1.03212 3.60046 0.864072 3.63676 0.708995 3.70655C0.553918 3.77633 0.415297 3.87803 0.302173 4.005C0.189995 4.1315 0.105814 4.28028 0.0551477 4.44158C0.00448152 4.60289 -0.0115263 4.77308 0.00817329 4.941L1.07767 13.941C1.11236 14.2342 1.25395 14.5044 1.47534 14.6998C1.69674 14.8952 1.9824 15.002 2.27767 15H14.5214C14.8167 15.002 15.1024 14.8952 15.3238 14.6998C15.5451 14.5044 15.6867 14.2342 15.7214 13.941L16.7909 4.941C16.8105 4.77302 16.7944 4.6028 16.7436 4.44149C16.6928 4.28019 16.6085 4.13144 16.4962 4.005ZM8.39617 1.2C9.03269 1.2 9.64314 1.45286 10.0932 1.90294C10.5433 2.35303 10.7962 2.96348 10.7962 3.6H5.99617C5.99617 2.96348 6.24903 2.35303 6.69912 1.90294C7.1492 1.45286 7.75965 1.2 8.39617 1.2ZM14.5282 13.8C14.526 13.8008 14.5236 13.8008 14.5214 13.8H2.26492L1.20217 4.8H15.5962L14.5282 13.8Z" fill="#1E2525"/>
      </svg>
    `;
    console.log("quickBuyButton added:", quickBuyButton);

    // --- Image link ko naye container mein wrap karein ---
    const link = item.querySelector(".kmnx-card-img-link");

    const container = document.createElement("div");
    container.className = "images_variant_container";
    container.style.position = "relative";
    container.appendChild(link);
    item.prepend(container);

    // --- Product handle URL se extract karein ---
    let productHandle;
    if (link) {
      link.style.position = "relative";

      const href = link.getAttribute("href");
      const productUrl = href.split("?")[0];
      productHandle = productUrl.split("/products/")[1];

      const params = new URLSearchParams(href.split("?")[1]);
      const variantId = params.get("variant");
      const fromElement = params.get("from_element");

      console.log("Handle:", productHandle);
    }

    // --- Quick Buy Drawer create karein aur container mein daalein ---
    const createBuyDrawer = document.createElement("quick-buy-drawer");
    container.appendChild(quickBuyButton);
    container.appendChild(createBuyDrawer);

    // --- Drawer ko product data ke saath refresh karein ---
    const quickBuyDrawer = item.querySelector("quick-buy-drawer");
    if (quickBuyDrawer && typeof quickBuyDrawer.refreshFromProductJson === "function") {
      quickBuyDrawer.refreshFromProductJson(productHandle);
      // console.log("quick_buy_drawer", quickBuyDrawer);
    }
  }

  function watchKimonixElements(durationMs) {
    const duration = durationMs || 10000;
    const foundElements = new Set();

    // Pehle se maujood cards process karein
    document.querySelectorAll(".kmnx-single-row-card").forEach(function (el) {
      foundElements.add(el);
      createQuickdrawerElement(el);
      console.log("Kimonix element (already present):", el);
    });

    // Naye cards ko dynamically detect karein
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (
            node.classList &&
            node.classList.contains("kmnx-single-row-card") &&
            !foundElements.has(node)
          ) {
            foundElements.add(node);
            createQuickdrawerElement(node);
            console.log("Naya Kimonix element render hua:", node);
          }

          if (node.querySelectorAll) {
            node.querySelectorAll(".kmnx-single-row-card").forEach(function (el) {
              if (!foundElements.has(el)) {
                foundElements.add(el);
                createQuickdrawerElement(el);
                console.log("Naya Kimonix element (nested) render hua:", el);
              }
            });
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Fixed duration ke baad observer band kar dein
    setTimeout(function () {
      observer.disconnect();
      console.log("--- Watch khatam ---");
      console.log("Total .kmnx-single-row-card mile:", foundElements.size);
      console.log(foundElements);
    }, duration);
  }

  document.addEventListener("DOMContentLoaded", function () {
    watchKimonixElements(30000);
  });
})();